import { render, staticRenderFns } from "./CostumeOrders.vue?vue&type=template&id=fd2ee55c&scoped=true"
import script from "./CostumeOrders.vue?vue&type=script&lang=js"
export * from "./CostumeOrders.vue?vue&type=script&lang=js"
import style0 from "./CostumeOrders.vue?vue&type=style&index=0&id=fd2ee55c&prod&scoped=true&lang=css"
import style1 from "./CostumeOrders.vue?vue&type=style&index=1&id=fd2ee55c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2ee55c",
  null
  
)

export default component.exports